import React from 'react';

import { EmailPreview } from './EmailPreview';
import { StyledModal } from './styles';

export { EmailPreview };

export const EmailBodyPreviewModal = ({
  isOpen,
  onClose,
  initialLogId,
  data,
}) => (
  <StyledModal
    visible={isOpen}
    onCancel={onClose}
    title="Prévia"
    footer={false}
    width="80%"
    destroyOnClose
  >
    {isOpen && <EmailPreview logId={initialLogId} data={data} />}
  </StyledModal>
);
